import { message } from 'antd';
import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { addUpdateRisUserMipsAPI, addUserSkillsAPI, assignUserMipsAPI, createRisUserAPI, deleteUserSkillsAPI, fetchUserMipsAPI, fetchUserSkillsAPI, getAllDoctorsAPI, getAllTechniciansAPI, getAllUsers, getRisUsersWithMipsAPI, registerUser, resetUserPasswordAPI, unAssignUserMipAPI, updateUserAccountAPI, updateUserMipsAPI, updateRisUserAPI, deleteRisUserAPI } from "../../../services/users-service";
import { HIDE_MODAL, SUBMIT_ERROR, SUBMIT_START, UPDATE_MODAL_DATA } from "../../actions/admin/modalActions";
import {
    ADD_UPDATE_RIS_USER_MIPS,
    ADD_UPDATE_RIS_USER_MIPS_ERROR,
    ADD_UPDATE_RIS_USER_MIPS_START, ADD_UPDATE_RIS_USER_MIPS_SUCCESS,
    ADD_USER,
    ADD_USER_ERROR,
    ADD_USER_SKILL,
    ADD_USER_SKILL_ERROR,
    ADD_USER_SKILL_START,
    ADD_USER_SKILL_SUCCESS,
    ADD_USER_SUCCESS,
    ASSIGN_USER_MIP,
    ASSIGN_USER_MIP_SUCCESS,
    CREATE_RIS_USER,
    CREATE_RIS_USER_ERROR,
    CREATE_RIS_USER_START, CREATE_RIS_USER_SUCCESS,
    DELETE_USER_SKILL,
    DELETE_USER_SKILL_ERROR,
    DELETE_USER_SKILL_START,
    DELETE_USER_SKILL_SUCCESS,
    FETCH_ALL_DOCTORS,
    FETCH_ALL_DOCTORS_ERROR,
    FETCH_ALL_DOCTORS_SUCCESS,
    FETCH_ALL_TECHNICIANS,
    FETCH_ALL_TECHNICIANS_ERROR,
    FETCH_ALL_TECHNICIANS_SUCCESS,
    FETCH_RIS_USERS_WITH_MIPS,
    FETCH_RIS_USERS_WITH_MIPS_ERROR, FETCH_RIS_USERS_WITH_MIPS_START,
    FETCH_RIS_USERS_WITH_MIPS_SUCCESS,
    FETCH_USERS,
    FETCH_USERS_ERROR,
    FETCH_USERS_START, FETCH_USERS_SUCCESS,
    FETCH_USER_MIPS,
    FETCH_USER_MIPS_ERROR,
    FETCH_USER_MIPS_SUCCESS,
    FETCH_USER_SKILLS,
    FETCH_USER_SKILLS_ERROR,
    FETCH_USER_SKILLS_START, FETCH_USER_SKILLS_SUCCESS,
    RESET_USER_PASSWORD,
    RESET_USER_PASSWORD_ERROR,
    RESET_USER_PASSWORD_START, RESET_USER_PASSWORD_SUCCESS,
    SET_USERS_PAGINATION, UNASSIGN_USER_MIP,
    UNASSIGN_USER_MIP_ERROR,
    UNASSIGN_USER_MIP_SUCCESS,
    UPDATE_USER_ACCOUNT,
    UPDATE_USER_ACCOUNT_ERROR,
    UPDATE_USER_ACCOUNT_START, UPDATE_USER_ACCOUNT_SUCCESS, UPDATE_USER_MIPS, UPDATE_USER_MIPS_SUCCESS, UPDATE_RIS_USER, UPDATE_RIS_USER_START, UPDATE_RIS_USER_SUCCESS, UPDATE_RIS_USER_ERROR, DELETE_RIS_USER, DELETE_RIS_USER_SUCCESS, DELETE_RIS_USER_ERROR
} from "../../actions/admin/usersActions";
import { history } from '../../store';

function* fetchUsers({ payload }) {
    try {
        yield put({ type: FETCH_USERS_START })
        const response = yield call(getAllUsers, payload);
        if (response.success) {

            const pagination = {
                currentPage: payload.pageNo,
                pageSize: payload.pageSize,
                totalPages: response.data.totalPages,
                totalItems: response.data.totalItems,
            }
            yield put({ type: SET_USERS_PAGINATION, pagination });
            yield put({ type: FETCH_USERS_SUCCESS, users: response.data.users })
        } else {
            yield put({ type: FETCH_USERS_ERROR, error: response.error })
            message.error('Failed to fetch users!');
        }
    } catch (error) {
        yield put({ type: FETCH_USERS_ERROR, error })
        message.error('Failed to fetch users!');
    }
}

function* addUser({ user }) {
    try {
        yield put({ type: SUBMIT_START })
        const response = yield call(registerUser, user);
        if (response.success) {
            yield put({ type: ADD_USER_SUCCESS, user: response.user })
            message.success('User created successfully.');
            history.replace({
                pathname: '/admin/master/edit-user',
                state: {
                    formType: "Edit",
                    userId: response.user.userId
                }
            });
        } else {
            yield put({ type: ADD_USER_ERROR, error: response.error })
            yield put({ type: SUBMIT_ERROR })
            message.error(response.error);
        }
    } catch (error) {
        yield put({ type: ADD_USER_ERROR, error })
        yield put({ type: SUBMIT_ERROR })
        message.error('Failed to create user!');
    }
}

function* updateUserAccount({ userAccount }) {
    try {
        yield put({ type: UPDATE_USER_ACCOUNT_START })
        const response = yield call(updateUserAccountAPI, userAccount);
        if (response.success) {
            yield put({ type: UPDATE_USER_ACCOUNT_SUCCESS, userAccount: response.userAccount })
            yield put({ type: HIDE_MODAL })
            message.success('User account updated successfully.');
        } else {
            yield put({ type: UPDATE_USER_ACCOUNT_ERROR, error: response.error })
            message.error('Failed to update user account!');
        }
    } catch (error) {
        yield put({ type: UPDATE_USER_ACCOUNT_ERROR, error })
        message.error('Failed to update user account!');
    }
}

// function* updateUserSites({ user }) {
//     try {
//         yield put({ type: SUBMIT_START })
//         let userSites = [];
//         user.site.forEach(site => {
//             userSites.push({
//                 id: 0,
//                 siteId: site.id,
//                 userId: user.id
//             });
//         });
//         const response = yield call(updateUserSitesAPI, userSites);
//         if (response.success) {
//             yield put({ type: UPDATE_USER_SITES_SUCCESS, user })
//             yield put({ type: HIDE_MODAL })
//             message.success('User site info updated successfully.');
//         } else {
//             yield put({ type: UPDATE_USER_SITES_ERROR, error: response.error })
//             yield put({ type: SUBMIT_ERROR })
//             message.error('Failed to update user site info!');
//         }
//     } catch (error) {
//         yield put({ type: UPDATE_USER_SITES_ERROR, error })
//         yield put({ type: SUBMIT_ERROR })
//         message.error('Failed to update user site info!');
//     }
// }

function* resetUserPassword({ user }) {
    try {

        yield put({ type: RESET_USER_PASSWORD_START })
        const response = yield call(resetUserPasswordAPI, user.email);
        if (response.success) {
            yield put({ type: RESET_USER_PASSWORD_SUCCESS, accountInfo: response.accountInfo });
            yield put({ type: UPDATE_MODAL_DATA, data: { ...user, ...response.accountInfo } });
            message.success('Password reset successfully.');
        } else {
            yield put({ type: RESET_USER_PASSWORD_ERROR, error: response.error })
            message.error('Failed to reset password!');
        }
    } catch (error) {
        yield put({ type: RESET_USER_PASSWORD_ERROR, error })
        message.error('Failed to reset password!');
    }
}

function* fetchTechnicians({ payload }) {
    try {
        // yield put({ type: FETCH_ALL_TECHNICIANS_START })
        const response = yield call(getAllTechniciansAPI, payload.siteId);
        if (response.success) {
            yield put({ type: FETCH_ALL_TECHNICIANS_SUCCESS, technicians: response.technicians })
        } else {
            yield put({ type: FETCH_ALL_TECHNICIANS_ERROR, error: response.error })
            message.error('Failed to fetch technicians!');
        }
    } catch (error) {
        yield put({ type: FETCH_ALL_TECHNICIANS_ERROR, error })
        message.error('Failed to fetch technicians!');
    }
}

function* fetchDoctors() {
    try {
        // yield put({ type: FETCH_ALL_TECHNICIANS_START })
        const response = yield call(getAllDoctorsAPI);
        if (response.success) {
            yield put({ type: FETCH_ALL_DOCTORS_SUCCESS, doctors: response.doctors })
        } else {
            yield put({ type: FETCH_ALL_DOCTORS_ERROR, error: response.error })
            message.error('Failed to fetch doctors!');
        }
    } catch (error) {
        yield put({ type: FETCH_ALL_DOCTORS_ERROR, error })
        message.error('Failed to fetch doctors!');
    }
}

function* getRisUsersWithMips({ userId }) {
    try {
        yield put({ type: FETCH_RIS_USERS_WITH_MIPS_START })
        const response = yield call(getRisUsersWithMipsAPI, userId);
        if (response.success) {
            yield put({
                type: FETCH_RIS_USERS_WITH_MIPS_SUCCESS,
                payload: {
                    userId,
                    risUsers: response.data.length > 0 ? [...response.data] : []
                }
            })
        } else {
            yield put({ type: FETCH_RIS_USERS_WITH_MIPS_ERROR, error: response.error })
            message.error('Failed to fetch RIS users!');
        }
    } catch (error) {
        yield put({ type: FETCH_RIS_USERS_WITH_MIPS_ERROR, error })
        message.error('Failed to fetch RIS users!');
    }
}

function* createRisUser({ risUser }) {
    try {
        yield put({ type: CREATE_RIS_USER_START })
        const response = yield call(createRisUserAPI, risUser);
        if (response.success) {
            yield put({
                type: CREATE_RIS_USER_SUCCESS,
                risUserMips: response.risUserMips
            })
            message.success('Ris user created successfully.');
        } else {
            if (response.error) {
                yield put({ type: CREATE_RIS_USER_ERROR, error: response.error })
                message.error(response.error);
            } else {
                yield put({ type: CREATE_RIS_USER_ERROR, error: response.error })
                message.error('Failed to create ris user!');
            }
        }
    } catch (error) {
        yield put({ type: CREATE_RIS_USER_ERROR, error })
        message.error('Failed to create ris user!');
    }
}

function* addUpdateRisUserMips({ risUser }) {
    try {
        yield put({ type: ADD_UPDATE_RIS_USER_MIPS_START })
        const response = yield call(addUpdateRisUserMipsAPI, risUser);
        if (response.success) {
            yield put({
                type: ADD_UPDATE_RIS_USER_MIPS_SUCCESS,
                risUserMips: response.risUserMips
            })
            message.success('Ris user mips saved successfully.');
        } else {
            if (response.error) {
                yield put({ type: ADD_UPDATE_RIS_USER_MIPS_ERROR, error: response.error })
                message.error(response.error);
            } else {
                yield put({ type: ADD_UPDATE_RIS_USER_MIPS_ERROR, error: response.error })
                message.error('Failed to save ris user mips!');
            }
        }
    } catch (error) {
        yield put({ type: ADD_UPDATE_RIS_USER_MIPS_ERROR, error })
        message.error('Failed to save ris user mips!');
    }
}

function* getUserSkills({ userId }) {
    try {
        yield put({ type: FETCH_USER_SKILLS_START })
        const response = yield call(fetchUserSkillsAPI, userId);
        if (response.success) {
            yield put({
                type: FETCH_USER_SKILLS_SUCCESS,
                payload: {
                    userId,
                    userSkills: response.data
                }
            })
        } else {
            if (response.error) {
                yield put({ type: FETCH_USER_SKILLS_ERROR, error: response.error })
                message.error(response.error);
            } else {
                yield put({ type: FETCH_USER_SKILLS_ERROR, error: response.error })
                message.error('Failed to fetch user skills!');
            }
        }
    } catch (error) {
        yield put({ type: FETCH_USER_SKILLS_ERROR, error })
        message.error('Failed to fetch user skills!');
    }
}

function* addUserSkill({ userSkill }) {
    try {
        yield put({ type: ADD_USER_SKILL_START })
        const response = yield call(addUserSkillsAPI, userSkill);
        if (response.success) {
            yield put({
                type: ADD_USER_SKILL_SUCCESS,
                userSkill: response.data
            }); 
            message.success("User skill updated successfully");
        } else {
            if (response.error) {
                yield put({ type: ADD_USER_SKILL_ERROR, error: response.error })
                message.error(response.error);
            } else {
                yield put({ type: ADD_USER_SKILL_ERROR, error: response.error })
                message.error('Failed to add user skill!');
            }
        }
    } catch (error) {
        yield put({ type: FETCH_USER_SKILLS_ERROR, error })
        message.error('Failed to add user skill!');
    }
}

function* deleteUserSkill({ userSkill }) {
    try {
        yield put({ type: DELETE_USER_SKILL_START })
        const response = yield call(deleteUserSkillsAPI, userSkill);
        if (response.success) {
            yield put({
                type: DELETE_USER_SKILL_SUCCESS,
                userSkill
            });
            message.success("User skill updated successfully");
        } else {
            if (response.error) {
                yield put({ type: DELETE_USER_SKILL_ERROR, error: response.error })
                message.error(response.error);
            } else {
                yield put({ type: DELETE_USER_SKILL_ERROR, error: response.error })
                message.error('Failed to delete user skill!');
            }
        }
    } catch (error) {
        yield put({ type: FETCH_USER_SKILLS_ERROR, error })
        message.error('Failed to delete user skill!');
    }
}

function* updateRisUser({ risUser, callback }) {
    try {
        yield put({ type: UPDATE_RIS_USER_START })
        const response = yield call(updateRisUserAPI, risUser);
        if (response.success) {
            yield put({
                type: UPDATE_RIS_USER_SUCCESS,
                risUser: { ...risUser, ...response.risUser }
            })
            message.success('Ris user updated successfully.');
            if (callback) {
                callback();
            }
        } else {
            if (response.error) {
                yield put({ type: UPDATE_RIS_USER_ERROR, error: response.error })
                message.error(response.error);
            } else {
                yield put({ type: UPDATE_RIS_USER_ERROR, error: response.error })
                message.error('Failed to update ris user!');
            }
        }
    } catch (error) {
        yield put({ type: UPDATE_RIS_USER_ERROR, error })
        message.error('Failed to update ris user!');
    }
}

function* deleteRisUser({ payload }) {
    try {
        const response = yield call(deleteRisUserAPI, payload.userId, payload.risId);
        if (response.success) {
            yield put({
                type: DELETE_RIS_USER_SUCCESS,
                payload: payload
            })
            message.success('Ris user deleted successfully.');
        } else {
            if (response.error) {
                yield put({ type: DELETE_RIS_USER_ERROR, error: response.error })
                message.error(response.error);
            } else {
                yield put({ type: DELETE_RIS_USER_ERROR, error: response.error })
                message.error('Failed to delete ris user!');
            }
        }
    } catch (error) {
        yield put({ type: DELETE_RIS_USER_ERROR, error })
        message.error('Failed to delete ris user!');
    }
}

function* unAssignUserMip({ payload }) {
    try {
        const response = yield call(unAssignUserMipAPI, payload);
        if (response.success) {
            yield put({ type: UNASSIGN_USER_MIP_SUCCESS, userMipId: payload })
            message.success('Unassigned user mip successfully');
        } else {
            message.error('Failed to unassign user mip!');
        }
    } catch (error) {
        message.error('Failed to unassign user mip!');
    }
}


function* fetchUserMips({ payload }) {
    try {
        const response = yield call(fetchUserMipsAPI, payload);
        if (response.success) {
            yield put({
                type: FETCH_USER_MIPS_SUCCESS,
                userMips: response.data
            })
        } else {
            if (response.error) {
                yield put({ type: FETCH_USER_MIPS_ERROR, error: response.error })
                message.error(response.error);
            } else {
                yield put({ type: FETCH_USER_MIPS_ERROR, error: response.error })
                message.error('Failed to fetch user mips!');
            }
        }
    } catch (error) {
        yield put({ type: UNASSIGN_USER_MIP_ERROR, error })
        message.error('Failed to fetch user mips!');
    }
}



function* assignUserMip({ payload, callback }) {
    try {
        const response = yield call(assignUserMipsAPI, payload);
        if (response.success) {
            if (callback) {
                callback(response.userMip);
            }
            yield put({ type: ASSIGN_USER_MIP_SUCCESS, userMip: response.userMip })
            message.success('Assigned user mip successfully');
        } else {
            if (response.error) {
                message.error(response.error);
            } else {
                message.error('Failed to assigned user mip!');
            }
        }
    } catch (error) {
        message.error('Failed to assign user mip!');
    }
}

function* updateUserMips({ payload }) {
    try {
        const response = yield call(updateUserMipsAPI, payload.userMips);
        if (response.success) {
            yield put({ type: UPDATE_USER_MIPS_SUCCESS, userMips: payload.userMips })
            message.success('Updated user mips successfully');
            if (payload.userId) {
                yield put({ type: FETCH_RIS_USERS_WITH_MIPS, userId: payload.userId });
            }
        } else {
            if (response.error) {
                message.error(response.error);
            } else {
                message.error('Failed to update user mips!');
            }
        }
    } catch (error) {
        message.error('Failed to update user mips!');
    }
}


function* usersWatcher() {
    yield takeEvery(FETCH_USERS, fetchUsers)
    yield takeEvery(ADD_USER, addUser)
    yield takeLatest(UPDATE_USER_ACCOUNT, updateUserAccount)
    // yield takeLatest(UPDATE_USER_SITES, updateUserSites)
    yield takeLatest(RESET_USER_PASSWORD, resetUserPassword)
    yield takeLatest(FETCH_RIS_USERS_WITH_MIPS, getRisUsersWithMips)
    yield takeLatest(FETCH_USER_SKILLS, getUserSkills)
    yield takeLatest(ADD_USER_SKILL, addUserSkill)
    yield takeLatest(DELETE_USER_SKILL, deleteUserSkill)
    yield takeLatest(CREATE_RIS_USER, createRisUser)
    yield takeLatest(ADD_UPDATE_RIS_USER_MIPS, addUpdateRisUserMips)
    yield takeLatest(UPDATE_RIS_USER, updateRisUser)
    yield takeLatest(DELETE_RIS_USER, deleteRisUser)
    yield takeLatest(UNASSIGN_USER_MIP, unAssignUserMip)
    yield takeLatest(FETCH_USER_MIPS, fetchUserMips)
    yield takeLatest(ASSIGN_USER_MIP, assignUserMip)
    yield takeLatest(UPDATE_USER_MIPS, updateUserMips)
}

function* techniciansWatcher() {
    yield takeEvery(FETCH_ALL_TECHNICIANS, fetchTechnicians)
}

function* doctorsWatcher() {
    yield takeEvery(FETCH_ALL_DOCTORS, fetchDoctors)
}

export default function* rootSaga() {
    yield all([
        usersWatcher(),
        techniciansWatcher(),
        doctorsWatcher()
    ]);
}